import { ErrorBarCombinedProps } from './types';

const usePresenter = (props: ErrorBarCombinedProps): ErrorBarCombinedProps => {
  return props;
};

export default usePresenter;
